import React from "react";
import { switchReportStyle } from "../../components/Reports/Timps/Switch/style/index";
import { themeService } from "../../theme/service/activeTheme.service";
import { iconToShow, iconTwoShow } from "../../components/Reports/variables";
import { Row, Col } from "reactstrap";
import { trackReportStyle } from "../../components/Reports/Timps/style";
import _ from "lodash";
import Icon from "react-icons-kit";
import { settings } from "react-icons-kit/ionicons/settings";

/**
 *
 * @param {string} title The main title of the report
 * @param {string | undefined} subTitle Subtitle to be displayed below the main title
 * @param {boolean} hideLogo hides the logo if true, displays the logo if false
 * @param {string|undefined} displayRevisedAreaText Text to be displayed on the right corner of the title if provided
 * @param {string|undefined} fontSizeOverride Override main title font size
 * @param {boolean | undefined} centerTitle force center align the main title
 * @param {boolean | undefined} isMaintenance Display maintenance icon with main title
 * @returns rendered Title Section component
 */
const ReportTitleSection = ({
  title,
  subTitle,
  hideLogo,
  displayRevisedAreaText,
  fontSizeOverride,
  centerTitle,
  isMaintenance,
  overrideTitleStyle,
  showSecondLogo = false,
}) => {
  const logo1Source = themeService(iconToShow);
  const logo2Source = themeService(iconTwoShow);
  return (
    <div
      className={`report-title-flex-container ${displayRevisedAreaText ? "revised" : ""}`}
      style={overrideTitleStyle ? overrideTitleStyle : {}}
    >
      {hideLogo ? null : (
        <div className="report-title-logo">
          <span>{logo1Source && <img src={logo1Source} alt="Logo" style={themeService(trackReportStyle.logoStyle)} />}</span>
        </div>
      )}

      <div className="report-title-value">
        <h2
          style={_.merge(
            { ...themeService(switchReportStyle.headingStyle), transform: "translateX(-21px)" },
            { fontSize: fontSizeOverride ? fontSizeOverride : "23px" },
          )}
        >
          {isMaintenance ? <Icon size={32} style={{ padding: "0 15px 0 0", color: "var(--first)" }} icon={settings} /> : null}
          {title}
        </h2>
        {subTitle && (
          <h3 style={_.merge({ ...themeService(switchReportStyle.headingStyle), transform: "translateX(-21px)" }, { fontSize: "24px" })}>
            {subTitle}
          </h3>
        )}
      </div>
      {hideLogo ? null : showSecondLogo ? (
        <div className="report-title-logo">
          <span>{logo2Source && <img src={logo2Source} alt="Logo" style={themeService(trackReportStyle.logoStyle)} />}</span>
        </div>
      ) : null}
      {displayRevisedAreaText ? <div className="report-title-revised-area">{displayRevisedAreaText}</div> : null}

      {centerTitle ? (
        <div className="report-title-logo">
          <span style={{ border: "none" }}></span>
        </div>
      ) : null}
    </div>
  );
};

export default ReportTitleSection;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportTitleSection.jsx